import axios from 'axios'

export default {
  methods: {
    savePoster(payload) {
      return axios.post('/save-poster', payload)
    },
    updatePoster(posterId, payload) {
      return axios.post(`/poster/${ posterId }/update`, payload)
    },
    getPoster(params) {
      return axios.get('/get-poster-data', { params })
    },
  }
}
